class SectionVideoGallery implements ng.IComponentController {
    ltTitle: string;
    description: string;
    videos: string[];
    buttons: anm.LandingButtonData[] | boolean;
}

angular.module('animatronApp.sectionVideoGallery', []).component('sectionVideoGallery', {
    bindings: {
        ltTitle: '<',
        description: '<',
        videos: '<',
        buttons: '<'
    },
    controller: SectionVideoGallery,
    templateUrl: require('landing-template/components/sections/section-video-gallery.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVideoGallery.ts